/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

/*import url and gateway methods */
import { putData, getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import {
  appUserHeaderLinks,
  appUserProfileLink,
} from "helper/AppUserHelper/AppUserHelper";
import { useTranslation } from "react-i18next";
import { getPublicIP } from "helper/AuthHelper/AuthHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

const AppUserPasswordBody = () => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation
  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");

  // State to manage form inputs
  const [passwordData, setPasswordData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  /* hook for validation */
  const [errors, setErrors] = useState({
    newPassword: "",
    confirmPassword: "",
    passwordMismatch: "",
    passwordStrength: "",
  });
  const params = useParams();

  const commonHeaderObject = appUserHeaderLinks(params.id, t);

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("App User"), link: appUserProfileLink },
    { title: t("Password") },
  ];

  //function for get user details
  const getUserDetails = async () => {
    const userPublicIp = await getPublicIP();

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${params.id}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status && response.data) {
        const data = response.data;

        setName(data.name || "");
        setSurName(data.surname || "");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Function to handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({
      ...passwordData,
      [name]: value,
    });

    setErrors({
      newPassword: "",
      confirmPassword: "",
      passwordMismatch: "",
      passwordStrength: "",
    });
  };

  /* function to validate password */
  const validate = () => {
    let newErrors = {
      newPassword: "",
      confirmPassword: "",
      passwordMismatch: "",
      passwordStrength: "",
    };
    let isValid = true;

    // Validate new password
    if (!passwordData.newPassword.trim()) {
      newErrors.newPassword = t("Please enter your new password.");
      isValid = false;
    }

    // Validate confirm password
    if (!passwordData.confirmPassword.trim()) {
      newErrors.confirmPassword = t("Please confirm your new password.");
      isValid = false;
    }

    // Check if passwords match
    if (
      passwordData.newPassword &&
      passwordData.confirmPassword &&
      passwordData.newPassword !== passwordData.confirmPassword
    ) {
      newErrors.passwordMismatch = t(
        "Passwords do not match. Please re-enter."
      );
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Function to handle password change
  const changePasswordHandler = async (e) => {
    e.preventDefault();
    if (validate()) {
      const userPublicIp = await getPublicIP();

      setIsLoading(true);
      try {
        let passwordUpdatedData = {
          password: passwordData.confirmPassword,
        };

        // Construct the request URL by combining the API base URL, the specific API endpoint (API_UPDATE_APP_USER),
        // and including a token as a query parameter for authentication.
        let requestUrl =
          url.API_BASE_URL +
          url.API_CHANGE_USER_PASSWORD +
          `/${params.id}` +
          `?token=${token}&userip=${userPublicIp}`;

        // Send a request to change the password using putData or your preferred method
        const response = await putData(requestUrl, passwordUpdatedData);

        console.log(response);

        setIsLoading(false);
        // Handle the response as needed, e.g., check for success or errors
        if (response.status) {
          resetHandler();

          setMessageType("success");
          setAlertMessage(t("Password changed successfully."));
          setShowAlert(true);
        } else {
          setMessageType("error");
          setAlertMessage(t("Password change failed. Please try again."));
          setShowAlert(true);
        }
      } catch (error) {
        // Handle any network or request errors

        setMessageType("error");
        setAlertMessage(t("An error occurred while changing the password."));
        setShowAlert(true);
      }
    }
  };

  const onAlertClose = () => {
    // Set the state variable 'showAlert' to false to hide the alert.
    setShowAlert(false);

    // Clear the alert message by setting the state variable 'alertMessage' to an empty string.
    setAlertMessage("");

    // Clear the alert type by setting the state variable 'messageType' to an empty string.
    setMessageType("");
  };

  // Function to reset form inputs and message state
  const resetHandler = () => {
    setPasswordData({
      newPassword: "",
      confirmPassword: "",
    });

    onAlertClose();
  };

  useEffect(() => {
    if (params.id) {
      getUserDetails();
    }
  }, [params.id]);

  return (
    <div id="content_wrapper">
      <section className="event-details-wrapper bg-white pb-5">
        {/* ---- expert details common header ---- */}
        {params.id && (
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Password")}
          />
        )}

        {/* ----- change password form start -------- */}
        <div className="container-fluid px-3 px-lg-5 pt-4 pt-md-0">
          {/* ---- bread crumb ------- */}
          <BreadCrumb
            breadCrumbText={breadcrumbText}
            bottom={true}
            displayName={`${name} ${surName}`}
          />

          {/* ----- change password form -------- */}
          <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
            <h3 className="mb-2">{t("Change Password")}</h3>
            <p className="text-muted fs-sm mb-4">
              {t("Choose a strong password you haven't used before.")}
            </p>

            {/* 
          - The form now handles submission via onSubmit for better semantics and accessibility.
          - The button's type is "submit".
        */}
            <form onSubmit={changePasswordHandler}>
              {/* New Password Input start */}
              {/* 
            - This uses the standard Bootstrap horizontal form layout.
            - `row` now directly contains the label and the input column.
            - `col-form-label` vertically aligns the label with the input.
            - `mb-4` provides consistent spacing between form fields.
          */}
              <div className="row mb-4">
                <label
                  htmlFor="newPassword"
                  className="col-md-3 col-form-label fw-semibold fs-sm"
                >
                  {t("New Password")}
                </label>
                <div className="col-md-9">
                  <input
                    type="password"
                    id="newPassword"
                    name="newPassword"
                    className={`form-control fs-sm shadow-none border border-gray-300 ${
                      errors.newPassword || errors.passwordStrength
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder={t("Enter a strong new password")}
                    value={passwordData.newPassword}
                    onChange={handleInputChange}
                  />
                  {errors.newPassword && (
                    <div className="invalid-feedback">{errors.newPassword}</div>
                  )}
                  {errors.passwordStrength && (
                    <div className="invalid-feedback">
                      {errors.passwordStrength}
                    </div>
                  )}
                </div>
              </div>
              {/* New Password Input end */}

              {/* Confirm Password Input start */}
              <div className="row mb-4">
                <label
                  htmlFor="confirmPassword"
                  className="col-md-3 col-form-label fw-semibold fs-sm"
                >
                  {t("Confirm Password")}
                </label>
                <div className="col-md-9">
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    className={`form-control fs-sm shadow-none border border-gray-300 ${
                      errors.confirmPassword || errors.passwordMismatch
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder={t("Re-enter your new password to confirm")}
                    value={passwordData.confirmPassword}
                    onChange={handleInputChange}
                  />
                  {errors.confirmPassword && (
                    <div className="invalid-feedback">
                      {errors.confirmPassword}
                    </div>
                  )}
                  {errors.passwordMismatch && (
                    <div className="invalid-feedback">
                      {errors.passwordMismatch}
                    </div>
                  )}
                </div>
              </div>
              {/* Confirm Password Input end */}

              {/* Action Buttons start */}
              {/* 
            - The button is placed in an offset column to align perfectly 
              with the input fields on md+ screens.
            - The redundant inline style for the cursor is removed.
          */}
              <div className="row">
                <div className="col-md-9 offset-md-3">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {t("Update Password")}
                    {isLoading && (
                      <div
                        className="ms-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                </div>
              </div>
              {/* Action Buttons end */}
            </form>
          </div>
        </div>
        {/* ----- change password form end -------- */}
      </section>

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default AppUserPasswordBody;
